// =======================================
// modules/companyIntro.js
// 会社紹介セクションの表示アニメーション
//
// - 見た目の動きは CSS 側で担当
// - この JS は「セクションが画面に入ったら1回だけ class を付ける」だけを担当
// =======================================

import { prefersReducedMotion } from "../core/prefers-reduced-motion.js";

const SELECTOR    = ".p-company--top";
const READY_CLASS = "is-company-intro-ready";
const ACTIVE_CLASS = "is-company-animated";

/**
 * セクションがスクロールで「見える位置」に入ったか判定
 * - rect.top < viewportHeight * 0.90: セクション上端がビューポートの90%以内に入ったら発火
 */
function isInRevealZone(element) {
  if (typeof window === "undefined") return false;

  const rect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  return rect.top < viewportHeight * 0.90 && rect.bottom > 0;
}

export function initCompanyIntro() {
  const section = document.querySelector(SELECTOR);
  if (!(section instanceof HTMLElement)) return;

  const reveal = () => {
    section.classList.add(ACTIVE_CLASS);
  };

  // reduced motion：隠さずすぐ表示状態にする
  if (prefersReducedMotion()) {
    section.classList.add(READY_CLASS, ACTIVE_CLASS);
    return;
  }

  section.classList.add(READY_CLASS);

  // IntersectionObserver 非対応の環境では即表示
  if (typeof IntersectionObserver === "undefined") {
    reveal();
    return;
  }

  let observer = null;

  const revealOnce = () => {
    reveal();
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  // rootMargin -10% でビューポートの上90%に入った時に発火
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealOnce();
        }
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  observer.observe(section);

  // ページ途中からリロードされた場合の保険（スクロール済みで既に見えている）
  requestAnimationFrame(() => {
    if (section.classList.contains(ACTIVE_CLASS)) return;
    if (isInRevealZone(section)) revealOnce();
  });
}
